import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  menu: any ;
  constructor(
    private settings: SettingsService
  ) {
   this.loadSideMenu();
   }


   toggleSidebar() {
    const body = document.getElementById("main-wrapper");
  
    if (body) {
      body.classList.toggle("mini-sidebar");
    }
  }
  
   loadSideMenu(){
    this.settings.cargarAjustes();
    this.menu = [
      {
        titulo: 'Principal',
        icon: 'mdi mdi-view-dashboard',
        submenu: [
          { titulo: 'Usuarios', url: '/usuarios' },
        ]
      },
      {
        titulo: 'SAAM',
        icon: 'mdi mdi-book-open',
        submenu: [
          { titulo: 'Claves de agente', url: '/claves-agente' },
          { titulo: 'Perfil de usuario restringido', url: '/usuario-restringido' }
        ]
      }
    ];

    if (this.settings.amISuperInOrg() || this.settings.amISuperOutOrg() || this.settings.amIStaff) {
      if (this.settings.amISuperInOrg() || this.settings.amISuperOutOrg()){
        this.menu[0].submenu.push({ titulo:'Organizaciones', url: '/organizaciones' });
        this.menu[0].submenu.push({ titulo:'Reporte de Usuarios', url: '/usersreport' });
        this.menu[0].submenu.push({ titulo:'Control de Usuarios', url: '/controlusers' });
        this.menu[0].submenu.push({ titulo: 'Carrusel SAAM', url: '/carousel' });
        this.menu[0].submenu.push({ titulo: 'Actualizaciones SAAM', url: '/actualizaciones' });
      }
      this.menu[0].submenu.push({ titulo:'Perfiles', url: '/perfiles' });
      this.menu[0].submenu.push({ titulo: 'Dashboard', url: '/dashboard' });

      if (this.settings.amISuperInOrg() || this.settings.amISuperOutOrg() ){
        this.menu.push({
          titulo: 'Administración',
          icon: 'mdi mdi-folder',
          submenu:  [
            { titulo: 'Clientes', url: '/clientes' },
            { titulo: 'Planes', url: '/planes' },
            { titulo: 'Suscripciones', url: '/suscripciones/todas' }
          ]
        });

        this.menu[1].submenu.push({ titulo: 'Notificaciones', url: '/notificaciones' });

        this.menu.push({
          titulo: 'Servicios',
          icon: 'mdi mdi-assistant',
          submenu: [
            { titulo: 'Enviar masivos', url: '/servicios-masivos' },
            { titulo: 'SMTP', url: '/smtp' }
          ]
        });
      } else {
        this.menu.push({
          titulo: 'Administración',
          icon: 'mdi mdi-folder',
          submenu:  [
            { titulo: 'Suscripciones', url: '/suscripciones/todas' }
          ]
        });
      }
    }

    if ((this.settings.amIRoleSubAdmin() || this.settings.amIRoleAdmin() || this.settings.amIUser()) && !(this.settings.amISuperInOrg() || this.settings.amISuperOutOrg()) && !(this.settings.amIStaff)) {
      this.menu.push({
        titulo: 'Servicios',
        icon: 'mdi mdi-assistant',
        submenu: [
          { titulo: 'SMTP', url: '/smtp' }
        ]
      });
    }

    if(this.settings.CanICrearUsuariosApp()){
      let serviciosMenu = this.menu.find((item: any) => item.titulo === 'Servicios');
      if (!serviciosMenu) {
        serviciosMenu = {
          titulo: 'Servicios',
          icon: 'mdi mdi-assistant',
          submenu: []
        };
        this.menu.push(serviciosMenu);
      }

      serviciosMenu.submenu.push({ titulo: 'Usuarios App', url: '/usuarios-app' });
    }

    this.resetMenuOpen();
  }

  private resetMenuOpen() {
    if (!this.menu) {
      return;
    }
    const syncItems = (items: any[]) => {
      items.forEach(item => {
        item.submenu = item.submenu || [];
        item.open = false;
        if (item.submenu.length) {
          syncItems(item.submenu);
        }
      });
    };
    syncItems(this.menu);
  }
}
